export * from './room-content-carousel-item';
export * from './room-content-carousel-item-bottom';
export * from './room-content-details';

import { RoomContentCarouselItemComponent } from './room-content-carousel-item';
import { RoomContentCarouselItemBottomComponent } from './room-content-carousel-item-bottom';
import { RoomContentDetailsComponent } from './room-content-details';




export const RoomContentAtoms = [
    RoomContentCarouselItemComponent,
    RoomContentCarouselItemBottomComponent,
    RoomContentDetailsComponent
]